import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { onMounted, onUnmounted, watch } from "vue";
import { useLotteryCountdownManager } from "../composables/use-lottery-countdown-manager";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { useProductPageLotteryCountdowns } from "./shared/composables/use-product-page-lottery-countdowns";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { LotteryUtils } from "@sazka/lotteries/js/utils/lottery-utils";
import { usePageVisibility } from "@sazka/utils/composables/use-page-visibility";


export default /*@__PURE__*/_defineComponent({
  __name: '_lottery-countdown',
  props: {
    lottery: {},
    isMobile: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const countdownClass = props.isMobile ? "pp-lottery-countdown--mobile" : "pp-lottery-countdown--desktop";

const { formatLotteryCountdown, startCountdown, killCountdown, formattedTime } = useProductPageLotteryCountdowns(
    props.lottery
);
const lotteries = [props.lottery];

const { countdowns, unsubscribe, initialLoadPromise } = useLotteryCountdownManager(lotteries);

const initCountdown = async () => {
    await initialLoadPromise;
    formatLotteryCountdown(countdowns.value[0].secondsRemaining, props.isMobile);
    startCountdown(() => formatLotteryCountdown(countdowns.value[0].secondsRemaining, props.isMobile));
};

const { isDocumentVisible } = usePageVisibility();
watch(isDocumentVisible, (value) => {
    if (value) {
        initCountdown();
    } else {
        killCountdown();
    }
});

onMounted(async () => {
    await initCountdown();
});

onUnmounted(() => {
    unsubscribe();
    killCountdown();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pp-lottery-countdown", _unref(countdownClass)])
  }, [
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock(DsIcon, {
          key: 0,
          name: _unref(LotteryUtils).isQuickLottery(_ctx.lottery) ? 'quick-lottery-thin' : 'time-thin'
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "pp-lottery-countdown__timer",
      innerHTML: _unref(formattedTime)
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})